/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 201 created object
 * @export
 * @interface PostFleetsFleetIdWingsWingIdSquadsCreated
 */
export interface PostFleetsFleetIdWingsWingIdSquadsCreated {
    /**
     * The squad_id of the newly created squad
     * @type {number}
     * @memberof PostFleetsFleetIdWingsWingIdSquadsCreated
     */
    squadId: number;
}

/**
 * Check if a given object implements the PostFleetsFleetIdWingsWingIdSquadsCreated interface.
 */
export function instanceOfPostFleetsFleetIdWingsWingIdSquadsCreated(value: object): value is PostFleetsFleetIdWingsWingIdSquadsCreated {
    if (!('squadId' in value) || value['squadId'] === undefined) return false;
    return true;
}

export function PostFleetsFleetIdWingsWingIdSquadsCreatedFromJSON(json: any): PostFleetsFleetIdWingsWingIdSquadsCreated {
    return PostFleetsFleetIdWingsWingIdSquadsCreatedFromJSONTyped(json, false);
}

export function PostFleetsFleetIdWingsWingIdSquadsCreatedFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostFleetsFleetIdWingsWingIdSquadsCreated {
    if (json == null) {
        return json;
    }
    return {
        
        'squadId': json['squad_id'],
    };
}

export function PostFleetsFleetIdWingsWingIdSquadsCreatedToJSON(json: any): PostFleetsFleetIdWingsWingIdSquadsCreated {
    return PostFleetsFleetIdWingsWingIdSquadsCreatedToJSONTyped(json, false);
}

export function PostFleetsFleetIdWingsWingIdSquadsCreatedToJSONTyped(value?: PostFleetsFleetIdWingsWingIdSquadsCreated | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'squad_id': value['squadId'],
    };
}

